import React, { Component } from 'react';
import './Success.css';
import redirectGIF from '../../assets/img/redirect.gif';

class Success extends Component {
    render() {
        return (
            <div className="success">
                <h2>Your delivery address was added successfully, redirecting back to merchant...</h2>
                <img src={redirectGIF} alt="redirecting" width="100%" />
            </div>
        );
    }
}

export default Success;